import { render, staticRenderFns } from "./UploadProcedimentos.vue?vue&type=template&id=726ff110&"
import script from "./UploadProcedimentos.vue?vue&type=script&lang=js&"
export * from "./UploadProcedimentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports